import * as React from 'react';

import type {EmailAddressee} from 'nutshell-core/types';

import {LimitedGroup} from '../limited-group/limited-group';
import {LinkedEntity} from '../linked-entity/linked-entity';
import {shouldShowDelimiter} from '../utils/should-show-delimiter';

import {normalizeEmailAddresseeEntity} from './helpers';

type Props = {
    emailAddressees: EmailAddressee[];
    showAll: boolean;
    useEntityColor?: boolean;
    useEntityColorIfUser?: boolean;
    showAddress?: boolean;
    numDisplayed?: number;
    shouldFlex?: boolean;
    isHoverable?: boolean;
};

export function EmailLinkedEntities(props: Props) {
    const linkedEntities = props.emailAddressees.map((addressee, index) => {
        const normalizedEntity = normalizeEmailAddresseeEntity(addressee);

        const getShouldUseEntityColor = () => {
            if (props.useEntityColor) {
                return true;
            } else if (props.useEntityColorIfUser) {
                return normalizedEntity.type === 'users';
            } else {
                return false;
            }
        };

        return (
            <span key={addressee.address} className='flex'>
                <LinkedEntity
                    useEntityColor={getShouldUseEntityColor()}
                    stopPropagation={true}
                    shouldClientRoute={true}
                    htmlUrl={normalizedEntity.htmlUrl || undefined}
                    type={normalizedEntity.type}
                    name={props.showAddress ? addressee.formatted : normalizedEntity.name}
                />
                {shouldShowDelimiter(index, props.emailAddressees.length) ? (
                    <span>,&nbsp;</span>
                ) : undefined}
            </span>
        );
    });

    if (props.showAll) {
        return linkedEntities;
    }

    return (
        <LimitedGroup
            models={linkedEntities}
            numDisplayed={props.numDisplayed || 1}
            shouldTruncate={true}
            shouldFlex={props.shouldFlex}
            isHoverable={props.isHoverable}
        />
    );
}
